// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3 2H10.75C11.85 2 12.75 2.9 12.75 4V11.5',
  'M4.5 6H2C1.72 6 1.5 5.78 1.5 5.5V3.5C1.5 2.67 2.17 2 3 2C3.83 2 4.5 2.67 4.5 3.5V12.5C4.5 13.33 5.17 14 6 14H12.5C13.6 14 14.5 13.1 14.5 12V12C14.5 11.72 14.28 11.5 14 11.5H8C7.72 11.5 7.5 11.72 7.5 12V12.5C7.5 13.33 6.83 14 6 14',
  'M7 5.5C8.25 4.8 9.25 6.2 10.5 5.5M7 8.5C8.25 7.8 9.25 9.2 10.5 8.5',
];
